import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 2.5rem;
  text-align: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding-top: 2rem;

  p {
    font-size: 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1rem;

    p {
      font-size: 1.875rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-top: 5rem;
    margin-bottom: 3.75rem;
  }
`;

export const Heading = styled.h2`
  font-size: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.5rem;
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 1fr;
  grid-row-gap: 1rem;
  padding-bottom: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 1.5rem;
    grid-row-gap: 1.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 0 2rem 5rem;
  }
`;
